import React from 'react';

interface NotificationsEmptyStateProps {
  title: string;
  description: string;
}

export const NotificationsEmptyState: React.FC<NotificationsEmptyStateProps> = ({
  title,
  description,
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      {/* Título */}
      <h3 className="text-lg font-semibold text-black mb-3">
        {title}
      </h3>
      
      {/* Descrição */}
      <p className="text-sm text-gray-600 max-w-sm leading-relaxed">
        {description}
      </p>
    </div>
  );
};

